import { render } from "./UserView.vue?vue&type=template&id=5bdc951b&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=5bdc951b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5bdc951b"

export default script